/** HTTPS must use the server's host-only secure cookie, never a legacy fallback. */
export function readSessionCsrfToken(
  cookies = typeof document === 'undefined' ? '' : document.cookie,
  protocol = typeof window === 'undefined' ? '' : window.location.protocol,
): string {
  const name = protocol === 'https:' ? '__Host-azr_csrf' : protocol === 'http:' ? 'azr_csrf' : '';
  if (!name) return '';
  const prefix = `${name}=`;
  const matches = cookies
    .split(';')
    .map((cookie) => cookie.trim())
    .filter((cookie) => cookie.startsWith(prefix));
  if (matches.length !== 1) return '';
  try {
    const token = decodeURIComponent(matches[0]!.slice(prefix.length));
    if (
      token.length > 4096 ||
      [...token].some(
        (character) => character.charCodeAt(0) <= 32 || character.charCodeAt(0) === 127,
      )
    )
      return '';
    return token;
  } catch {
    return '';
  }
}

/** Clear only readable CSRF projections; the server owns HttpOnly session revocation. */
export function clearSessionCsrfCookies(): void {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;
  if (window.location.protocol === 'https:') {
    document.cookie = '__Host-azr_csrf=; Max-Age=0; Path=/; SameSite=Lax; Secure';
    document.cookie = 'azr_csrf=; Max-Age=0; Path=/; SameSite=Lax; Secure';
  } else if (window.location.protocol === 'http:') {
    document.cookie = 'azr_csrf=; Max-Age=0; Path=/; SameSite=Lax';
  }
}
